import React from "react";
import { stepSevenData } from "./stepData";
import { Typography } from "@mui/material";
import tongueOut from "../../../../../Assets/Images/tongue-out.webp";

const StepSeven = () => {
  return (
    <>
      <div>
        <div className=" mt-3 d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: "23.8532px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepSevenData[0].heading}
          </Typography>
        </div>
        <ol
          style={{
            listStyle: "disc",
            fontSize: 16,
            lineHeight: "24px",
            letterSpacing: "0.08px",
            fontWeight: 500,
            fontFamily: "'Archivo',sans-serif",
          }}
          className="mt-3"
        >
          <li className="mt-2">
            Attractive Interest Rates starting from 8.65% p.a.
          </li>
          <li className="mt-2">
            Loan Tenure Up to 7 Years for flexible repayment.
          </li>
          <li className="mt-2">
            Low Processing Fees compared to private banks.{" "}
          </li>
          <li className="mt-2">
            Special Discounts for Women & Salaried Applicants.{" "}
          </li>
        </ol>
        <div className="tips mt-4 ">
          <div id="border_line"></div>
          <div id="tip__container" className="px-2 px-sm-4 py-4">
            <div className="px-3 py-2">
              <div className="d-flex flex-row gap-2 align-items-center">
                <img src={tongueOut} alt="" style={{ width: 30, height: 30 }} />
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#59266D",
                    // color: "yellow",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  MinEmi Tip:
                </Typography>
              </div>
              <div className="mt-2">
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#1F1F1F",
                    // color: "#f8f8f8",

                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  {stepSevenData[0].tip}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepSeven;
